var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowCircledBottomLeft = function SvgArrowCircledBottomLeft(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1215 16.5355C14.6738 16.5355 15.1215 16.0878 15.1215 15.5355C15.1215 14.9832 14.6738 14.5355 14.1215 14.5355L10.8788 14.5355L16.2428 9.17153C16.6333 8.781 16.6333 8.14784 16.2428 7.75731C15.8523 7.36679 15.2191 7.36679 14.8286 7.75731L9.46461 13.1213L9.46461 9.87863C9.46461 9.32635 9.0169 8.87863 8.46461 8.87863C7.91233 8.87863 7.46461 9.32635 7.46461 9.87863L7.46461 15.5355C7.46461 16.0878 7.91233 16.5355 8.46461 16.5355L14.1215 16.5355Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6569 17.6569C20.7811 14.5327 20.7811 9.46734 17.6569 6.34315C14.5327 3.21895 9.46739 3.21895 6.34319 6.34315C3.219 9.46734 3.219 14.5327 6.34319 17.6569C9.46738 20.7811 14.5327 20.7811 17.6569 17.6569ZM19.0711 19.0711C22.9764 15.1658 22.9764 8.83418 19.0711 4.92893C15.1659 1.02369 8.83422 1.02369 4.92898 4.92893C1.02374 8.83418 1.02373 15.1658 4.92898 19.0711C8.83422 22.9763 15.1659 22.9763 19.0711 19.0711Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })))));
};
export { SvgArrowCircledBottomLeft as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-circled-bottom-left.fc607f15.svg";